import React, {useContext, useEffect, useState} from "react";
import {IExpressionsParams} from "@leap4/entities-discrepancy-common";
import { ExpressionMetric, ExpressionOperator} from "../../../enums";
import {enumNamesToSelect, FormChips, Grid, FormHelperText, TextField} from "@leap4/frontend";
import {AlertContext} from "../AlertContex";
import {urlService} from "../../../../../routing/urlsService";

const MetricSelect = enumNamesToSelect(ExpressionMetric);
const OperatorSelect = enumNamesToSelect(ExpressionOperator);


export const ExpressionParamsForm = () => {
    const {alert, setAlert, dataPoints} = useContext(AlertContext);
    const alertParams = alert.params as IExpressionsParams;
    const [availableDataPoints, setAvailableDataPoints] = useState([]);
    useEffect(() => {
        const relevantDataPoint = dataPoints.filter(point => point.type === "server");
        setAvailableDataPoints(relevantDataPoint)
    }, [dataPoints]);

    const updateAlertParams= (e) =>{
        setAlert({...alert, params: {...alert.params, [e.target.name]: e.target.value}})
    };

    const updateRelevantPlatforms = (relevantPlatforms: string[]) => {
        setAlert({...alert, params: {...alert.params, relevantPlatforms: relevantPlatforms}})
    }

    const getLinkToEditDatePoint = (dataPointId) => {
        return urlService.editDataPoint(dataPointId)
    }

    return <>
        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8} >
                <FormHelperText>
                    Metric
                </FormHelperText>
                <MetricSelect
                    required
                    fullWidth
                    value={alertParams?.metric}
                    onChange={updateAlertParams}
                    name="metric"
                    style={{height:"43px"}}
                />
            </Grid>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Operator
                </FormHelperText>
                <OperatorSelect
                    required
                    fullWidth
                    value={alertParams?.operator}
                    onChange={updateAlertParams}
                    name="operator"
                    style={{height:"43px"}}
                />
            </Grid>
            <Grid item xs={3.8} md={3.8} >
                <FormHelperText>
                    Number
                </FormHelperText>
                <TextField
                    fullWidth
                    value= {alertParams?.number}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="number"
                    className={"gridItem"}
                />
            </Grid>
        </Grid>

        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8} style={{paddingTop: "10px"}}>
                <FormHelperText>
                    Window Loop Back
                </FormHelperText>
                <TextField
                    value={alertParams?.windowLoopBack}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="windowLoopBack"
                    className={"gridItem"}
                    fullWidth
                />
            </Grid>
            <Grid item xs={3.8} md={3.8} style={{paddingTop: "13px"}}  >
                <FormChips optionsList={availableDataPoints} valueKey={"_id"} labelKey={"name"}
                           onUpdateItems={updateRelevantPlatforms}
                           inputName={"Relevant Platforms"} enableCreate={false}
                           chips={[...(alert.params as any)?.relevantPlatforms]} link={getLinkToEditDatePoint} pureCreate={false}
                />
            </Grid>


        </Grid>


    </>
}